import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import { auth } from "./firebase";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ContentionPage from "./pages/ContentionPage";

function App() {
  const [user, setUser] = useState(undefined);
  const [otpVerified, setOtpVerified] = useState(false);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u);

      if (!u) {
        setOtpVerified(false);
        localStorage.removeItem("otpVerified");
      }
    });

    return () => unsub();
  }, []);

  useEffect(() => {
    const stored = localStorage.getItem("otpVerified") === "true";
    if (stored) setOtpVerified(true);
  }, []);

  if (user === undefined) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        {/* LOGIN */}
        <Route
          path="/"
          element={
            user ? (
              otpVerified ? (
                <Navigate to="/dashboard" />
              ) : (
                <Login setOtpVerified={setOtpVerified} />
              )
            ) : (
              <Login setOtpVerified={setOtpVerified} />
            )
          }
        />

        {/* DASHBOARD */}
        <Route
          path="/dashboard"
          element={user && otpVerified ? <Dashboard /> : <Navigate to="/" />}
        />
        <Route path="/contention/:token" element={<ContentionPage />} />
      </Routes>
    </Router>
  );
}

export default App;
